import { useEffect, useState } from "react";
import logo from "../assets/images/icon.png";
import { Link, usePage } from "@inertiajs/react";

const ACCENT = "#4096ff";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const url = usePage();

  const routeActive = (route) => url.url === route;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isLight = scrolled;

  // ✅ Style untuk link navigasi
  const linkStyle = (active) => ({
    color: active ? ACCENT : "inherit",
    textDecoration: "none",
    fontSize: isLight ? 13 : 14,
    fontWeight: 600,
    fontFamily: "'Quicksand', sans-serif",
    transition: "all 0.3s ease",
    opacity: active ? 1 : 0.85,
  });

  return (
    <nav
      style={{
        width: "calc(100% - 32px)",
        maxWidth: 400,
        position: "fixed",
        top: isLight ? 12 : 24,
        left: "50%",
        transform: "translateX(-50%)", // ✅ Center horizontal
        zIndex: 999,
        borderRadius: isLight ? 16 : 20,
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        backdropFilter: "blur(16px) saturate(1.4)",
        WebkitBackdropFilter: "blur(16px) saturate(1.4)",
        background: isLight
          ? "rgba(255, 255, 255, 0.85)"
          : "rgba(0, 0, 0, 0.35)",
        border: isLight
          ? "1px solid rgba(255, 255, 255, 0.7)"
          : "1px solid rgba(255, 255, 255, 0.15)",
        boxShadow: isLight
          ? "0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.7)"
          : "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
        color: isLight ? "#1a2332" : "#ffffffd9",
        padding: isLight ? "12px 32px" : "15px 28px",
      }}
    >
      {/* ✅ LAYOUT VERTIKAL (TETAP) */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", // ✅ SELALU VERTIKAL
          alignItems: "center",
          gap: isLight ? 4 : 8, // ✅ Jarak logo-menu
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {/* ✅ LOGO DI ATAS (POSISI TETAP) */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link href="/" style={{ textDecoration: "none" }}>
            <img
              src={logo}
              alt="Logo"
              style={{
                width: isLight ? 28 : 38, // ✅ 38px DEFAULT → 28px SAAT SCROLL
                height: "auto",
                borderRadius: "100%",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: isLight
                  ? `0 3px 12px ${ACCENT}20`
                  : `0 6px 24px ${ACCENT}30`,
              }}
            />
          </Link>
        </div>

        {/* ✅ MENU NAVIGASI HORIZONTAL DI BAWAH */}
        <ul
          style={{
            display: "flex",
            flexDirection: "row",
            listStyleType: "none",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            padding: 0,
            gap: isLight ? 18 : 24, // ✅ Jarak antar menu
            backgroundColor: "transparent",
            flexWrap: "nowrap",
          }}
        >
          <li>
            <Link style={linkStyle(routeActive("/"))} href={"/"}>
              Home
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/about"))} href={"/about"}>
              About
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/product"))} href={"/product"}>
              Product
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/contact"))} href={"/contact"}>
              Contact
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/galeri"))} href={"/galeri"}>
              Galeri
            </Link>
          </li>
        </ul>
      </div>

      {/* ✅ RESPONSIVE STYLES */}
      <style>{`
        @media (max-width: 768px) {
          nav {
            max-width: calc(100% - 24px) !important;
            padding: ${scrolled ? "10px 24px" : "16px 32px"} !important;
          }
          
          ul {
            gap: ${scrolled ? "14px" : "20px"} !important;
            flex-wrap: wrap;
          }
          
          img {
            width: ${scrolled ? "26px" : "34px"} !important;
          }
        }

        @media (max-width: 480px) {
          nav {
            padding: ${scrolled ? "8px 16px" : "12px 20px"} !important;
          }
          
          ul {
            gap: ${scrolled ? "10px" : "14px"} !important;
          }
          
          a {
            font-size: ${scrolled ? "11px" : "12px"} !important;
          }
          
          img {
            width: ${scrolled ? "24px" : "32px"} !important;
          }
        }
      `}</style>
    </nav>
  );
}
